import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=aafd112a&"
import script from "./SimpleTable.vue?vue&type=script&lang=ts&"
export * from "./SimpleTable.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QMarkupTable,QTable});
